import React, {PureComponent} from 'react';

import {Flex, Box} from 'reflexbox';
import MediaQuery from 'react-responsive';

import initialState from './data/initialState.js'
import AudioController from './util/audio.js';

import Navbar from './components/Navbar.js';
import Ai from './components/Ai.js';
import Chat from './components/Chat.js';

export default class App extends PureComponent {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.audio = new AudioController(
      this.updateAudioAmp,
      this.endAudio,
      this.updatePlaying,
    )
  }

  componentDidMount = () => {
    this.audio.loadAudioData('Hi.wav')
    .then(()=> {
      this.audio.play();
    })
  }

  toggleSound= () => {
    const sound = !this.state.sound;
    if (!sound) {this.audio.stop()};
    this.setState({sound})
  }

  updateAudioAmp = (audioAmp) => {
    this.setState({audioAmp})
  }

  endAudio = () => {
    this.updateAudioAmp(0)
  }

  updatePlaying = (playing) => {
    this.setState({playing})
  }

  replaceMessage = (messages, newMessage) => {
    return messages.map(message =>
      newMessage.responseTo === message.query ? newMessage : message
    )
  }

  addAudioResponse = (message) => {
    let messages;
    const query = message.query.trim().replace(/ /g, '+').replace('?', '_');
    const fileName = `${query}.wav`;

    this.audio.loadAudioData(fileName)
    .then(() => {
      this.audio.play();
      messages = this.replaceMessage(this.state.messages, message);
      return this.setState({messages});
    })
    .catch((err) => {
      message.text = "I'm sorry, you seem to be having network issues and I can't find the answer to your question";
      messages = this.replaceMessage(this.state.messages, message);
    })
  }

  addResponse = (message) => this.setState((state, props) => {
    const messages = this.replaceMessage(state.messages, message);
    return {messages};
  })

  addMessage = (message) => this.setState((state, props) => {
    const messages = [...state.messages, message];
    return {messages};
  })

  updateMessages = (newMessage) => {
    if (newMessage.responseTo) {
      if (newMessage.author === 'ai' && !newMessage.err) {
        this.addAudioResponse(newMessage)
      } else {
        this.addResponse(newMessage);
      }
    } else {
      this.addMessage(newMessage);
    }
  }

  deleteMessage = (deleteQuery) => {
    const messages = this.state.messages.filter(message =>
      deleteQuery !== message.query
    )

    this.setState({messages});
  }

  render() {
    return (
      <div>
        <MediaQuery minDeviceWidth={700}>
          {matches => ( matches ? (
            <div>
              <Navbar style={{height: '65px'}}/>
              <Flex style={{height: 'calc(100vh - 65px - 16px)'}} align={'center'} justify={'center'}>
                <Box lg={6}>
                  <Ai
                    audioAmp={this.state.audioAmp}
                    sound={this.state.sound}
                    toggleSound={this.toggleSound}
                    updatePlaying={this.updatePlaying}
                  />
                </Box>
                <Box lg={6}>
                  <Chat
                    playing={this.state.playing}
                    sound={this.state.sound}
                    messages={this.state.messages}
                    updateMessages={this.updateMessages}
                    deleteMessage={this.deleteMessage}
                    uuid={this.state.uuid}
                  />
                </Box>
              </Flex>
            </div>)
            : (
            <div>
              <Navbar style={{height: '48'}}/>
              <Flex style={{height: "calc(100vh - 48px - 16px)"}} align={'center'} justify={'center'} column={true}>
                <Box col={12} auto={true} style={{height: '100%'}}>
                  <Chat
                    playing={this.state.playing}
                    sound={this.state.sound}
                    messages={this.state.messages}
                    updateMessages={this.updateMessages}
                    deleteMessage={this.deleteMessage}
                    uuid={this.state.uuid}
                  />
                </Box>
              </Flex>
            </div>)
          )}
        </MediaQuery>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js